module.exports = __webpack_public_path__ + "static/media/GirlWithCurlyHair.fab51ac2.jpg";